<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
    import IconBarButton from '../iconBarButton/IconBarButton.svelte';
    import ButtonLink from '../buttonLink/ButtonLink.svelte';

    export let href;
    export let label;
    export let icon;
    export let disabled;

    $: component = href ? ButtonLink : IconBarButton;
    $: componentProps = href
        ? { title: label, iconBefore: icon, href, skin: 'button' }
        : { label, icon, size: 'base-12', shape: 'circular', showLabelText: true };
</script>

<svelte:component this={component} {...componentProps} {disabled} on:click />
